import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faLaptopCode,
  faChartLine,
  faBriefcase,
  faPaintBrush,
  faBullhorn,
  faEnvelope,
  faPhoneAlt,
  faMapMarkerAlt,
  faShieldAlt,
  faFileContract,
  faCookieBite,
  faTruck,
  faWarehouse,
  faShip
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';
import '../css/Footer.css';
import { Link } from "react-router-dom";
import { BaseUrl } from "../Services/Api";

const handleScroll = () => {
  const section = document.getElementById("courses");
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
  const home = document.getElementById("home");
  if (home) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};
const handleScrollHome = () => {

  const home = document.getElementById("home");
  if (home) {
    home.scrollIntoView({ behavior: "smooth" });
  }
};
const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row footer-content">
          {/* About Section */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
            <h3 className="footer-heading">OCP</h3>
            <p className="footer-about">
              Empowering learners worldwide with high-quality courses from industry experts.
            </p>
            <div className="social-icons">
              <a href="https://www.facebook.com/LSCIndiaOfficial/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://x.com/LogisticsSSC" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="linkedin.com/in/lscindiaofficial/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a href="https://www.instagram.com/logisticssectorskillcouncil/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.youtube.com/@logisticsSSC" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><div onClick={handleScrollHome} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faChevronRight} /> Home</div></li>
              <li><div onClick={handleScroll} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faChevronRight} /> Categories</div></li>
              <li><a href="https://lsc-india.com/" target="_blank"><FontAwesomeIcon icon={faChevronRight} /> LSC Website</a></li>
              <li><a href="https://edc.lsc-crm.in/" target="_blank"><FontAwesomeIcon icon={faChevronRight} />Executive Development Center</a></li>
              {/* <li><a href="/about"><FontAwesomeIcon icon={faChevronRight} /> </a></li> */}
            </ul>
          </div>

          {/* Categories */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
            <h3 className="footer-heading">Categories</h3>
            <ul className="footer-links">
              <li>
                <Link to={`/category/c4ca4238a0b923820dcc509a6f75849b`}>
                  <FontAwesomeIcon icon={faLaptopCode} /> Agri Logistics
                </Link>
              </li>
              <li>
                <Link to={`/category/c81e728d9d4c2f636f067f89cc14862c`}>
                  <FontAwesomeIcon icon={faChartLine} /> Aviation And Air Cargo
                </Link>
              </li>
              <li>
                <Link to={`/category/eccbc87e4b5ce2fe28308fd9f2a7baf3`}>
                  <FontAwesomeIcon icon={faBriefcase} /> E-Commerce
                </Link>
              </li>
              <li>
                <Link to={`/category/a87ff679a2f3e71d9181a67b7542122c`}>
                  <FontAwesomeIcon icon={faTruck} /> Land Transportation
                </Link>
              </li>
              <li>
                <Link to={`/category/e4da3b7fbbce2345d7772b0674a318d5`}>
                  <FontAwesomeIcon icon={faWarehouse} /> Logistics
                </Link>
              </li>
              <li>
                <Link to={`/category/1679091c5a880faf6fb5e6087eb1b2dc`}>
                  <FontAwesomeIcon icon={faShip} /> Maritime Logistics
                </Link>
              </li>
            </ul>

          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
            <h3 className="footer-heading">Contact Us</h3>
            <ul className="footer-contact">
              <li><FontAwesomeIcon icon={faEnvelope} />solutions@lsc-india.com , support.eid@lsc-india.com</li>
              <li><FontAwesomeIcon icon={faPhoneAlt} /> +91-9840098233 , +91-9500049669</li>
              <li><FontAwesomeIcon icon={faMapMarkerAlt} />No. 480 A, 7th Floor Khivraj Complex II Anna Salai,
                Nandanam, Chennai, Tamil Nadu - 600 035</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-6 col-12 mb-3 mb-md-0">
              <p className="copyright">© {new Date().getFullYear()} OCP. All rights reserved.</p>
            </div>
            <div className="col-md-6 col-12">
              <div className="footer-legal">
                <a href="/terms" target="_blank"><FontAwesomeIcon icon={faShieldAlt} /> Terms and Policy</a>
                {/* <a href="/terms"><FontAwesomeIcon icon={faFileContract} /> Terms of Service</a>
                <a href="/cookies"><FontAwesomeIcon icon={faCookieBite} /> Cookie Policy</a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;